module.exports = __webpack_public_path__ + "static/media/314.3d24766a.wav";